import React from "react";
import styles from "./SignupDone.module.scss";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";

const SignupDone: React.FC = () => {
  return (
    <Grid container component="main">
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <div className={styles.container}>
          <div className={styles.hero}></div>
          <div className={styles.main}>
            <div className={styles.text}>
              登録していただきありがとうございます。
              <br />
              入力いただいたメールアドレスに本登録のリンクを送信しました。
              <br />
              本登録の処理を実施してください
            </div>
            <div className={styles.logo}>
              <div className={styles.imgContainer}>
                <img
                  src={`${window.location.origin}/logo512.png`}
                  alt=""
                  className={styles.img}
                />
              </div>
              <div>torememo</div>
            </div>
          </div>
        </div>
      </Grid>
    </Grid>
  );
};

export default SignupDone;
